import { getScatter, initLink, network, onAppRemoveSession, scope, verifyProof } from '@/common/utils/client';
import Server from '@/common/utils/serviceApi';
import { Storage } from '@/common/utils/storage';
import { createSlice } from '@reduxjs/toolkit';
import { AccountStatus, setUserInfo } from './actions';
import { useAppDispatch } from '../index';

const initialState = {
    topBar: {
        title: '',
        goback: '',
    },
    account: {
        kyc: false,
        name: '',
        publicKey: '',
        status: 0,
    },
    themeMode: 'light',
    language: window.localStorage.getItem('lange') ?? 'zh_CN',
    showVote: false,
    showAddVote: false,
};

export const blockchains = [
    {
        chainId: network.chainId,
        name: network.blockchain,
        rpcEndpoints: [
            {
                protocol: network.protocol,
                host: network.host,
                port: 0,
            },
        ],
    },
];


export async function login_scatter() {
    try {
        const scatter: any = getScatter();
        const identity = await scatter.getIdentity({
            accounts: [{chainId: network.chainId, blockchain: network.blockchain}],
        });
        const account = identity?.accounts[0];
        return {
            identity,
            account
        }
    } catch (e) {
        console.error('login Error:', e);
    }
}

// export async function login_anchor() {
//     const link = initLink();
//     const identity = await link.login(scope);
//     const {proof} = await verifyProof(
//         link,
//         identity,
//     );
//     await onAppRemoveSession();
//     const walletAddress = proof.signer.actor.toString();
//     const authority = proof.signer.permission.toString();
//     const chainId = network.chainId;
//     const publicKey = identity.session.publicKey.toString()
    
//     console.log(publicKey,'publicKey');
//     console.log(authority,'authority');
//     Storage.setItem('authority', authority);
//     Storage.setItem('walletAddress', walletAddress);
//     Storage.setItem('chainId', chainId);
//     sessionStorage['link']= 'yes'

//     return {
//         account:{name:walletAddress,authority},
//         identity:{
//             publicKey,
//             kyc:false
//         }
//     }
// }

export async function login_anchor() {
    const link = initLink();
    let accountStatus: AccountStatus;
    let publicKey = "";
    const identity = await link.login(scope);
    const {proof} = await verifyProof(
        link,
        identity,
    );
    await onAppRemoveSession();
    const walletAddress = proof.signer.actor.toString();
    const authority = proof.signer.permission.toString();
    const chainId = network.chainId;
    
    console.log(authority,'authority');
    Storage.setItem('authority', authority);
    Storage.setItem('walletAddress', walletAddress);
    Storage.setItem('chainId', chainId);
    sessionStorage['link']= 'yes'
    try {
      const accountData: any = await Server.getPubkeyByAccount(
        walletAddress
      );
      console.log(accountData, "accountData");
      publicKey = accountData.permissions[0].required_auth.keys[0].key;
      accountStatus = 1;
    } catch (e) {
      console.log(e, "e");
      publicKey = "";
      accountStatus = 0;
    }

    return {
        account:{name:walletAddress,authority},
        identity:{
            publicKey,
            kyc:false
        }
    }
    // accountStore.setUserInfo({
    //   kyc: identity.kyc,
    //   name: walletAddress,
    //   publicKey: publicKey,
    //   status: accountStatus,
    // });
  }

const BaseInfoSlice = createSlice({
    name: 'base',
    initialState,
    reducers: {
        setTopBar(state, { payload: TopBar }) {
            state.topBar = TopBar;
        },
        setTheme(state, { payload: theme }) {
            state.themeMode = theme;
        },
        setLanguage(state, { payload: language }) {
            state.language = language;
            window.localStorage.setItem('lange', language);
        },
        setShowVote(state, { payload: showVote }) {
            state.showVote = showVote;
        },
        setAddShowVote(state, { payload: showVote }) {
            state.showAddVote = showVote;
        },
        setUserInfo(state, { payload: account }) {
            state.account = account;
        },
        // setTokenList(state, { payload: list }) {
        //     // if (state.tokenList.length === 5) {
        //         state.tokenList = list;
        //     // } else {
        //     //     state.tokenList = [...state.tokenList, ...list];
        //     // }
        //     const _tokenObject = {};
        //     list.forEach(ele => {
        //         _tokenObject[ele.coin] = ele;
        //         state.tokenInfo[ele.coin] = ele;
        //     });
        // },
    },
});
export default BaseInfoSlice.reducer;
